import React from 'react';
import { useSiteGatedFeature } from '../../../hooks/useSiteGatedFeature';
import DashboardV1 from './v1';
import DashboardV2 from './v2';

/**
 * Feature gate for the redesigned (V2) shift reporting page (UTR-REFLEX-1248).
 *
 * Resolves the `RCC_SHIFT_REPORTING_V2` flag (RnRRCCFacadeService IsFeatureEnabled)
 * and renders V2 when enabled, else the previous (V1) page. While unresolved
 * (`isV2Enabled === null`) it renders nothing — both pages fetch on mount, so
 * mounting V1 first and swapping to V2 on resolve would fetch twice. We wait and
 * mount the right page once. The unresolved window is a facade round-trip when
 * deployed, instant locally.
 *
 * Follows the established AgentChatPanelGated / CurrentPlanSummaryGated pattern.
 */
const SHIFT_REPORTING_V2_FEATURE_NAME = 'RCC_SHIFT_REPORTING_V2';

const Dashboard: React.FC = () => {
  const isV2Enabled = useSiteGatedFeature(SHIFT_REPORTING_V2_FEATURE_NAME);

  // Flag not resolved yet — render nothing so we don't mount a page we'd only
  // have to unmount once the flag lands (see the note above on avoiding double-fetch).
  if (isV2Enabled === null) {
    return null;
  }

  return isV2Enabled ? <DashboardV2 /> : <DashboardV1 />;
};

export default Dashboard;
